var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"page_tit"},[_vm._v(_vm._s(_vm.$t('ACCUMULATION_PAYMENT_LIST_DISPLAY_GROUP_TITLE')))]),_c('DisplayInfoSon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }